
















import { computed, defineComponent, PropType, ref, useFetch } from '@nuxtjs/composition-api'
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import { productTypeTag } from '~/utils/types/Product';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';
import { getProductTypeTag } from '~/utils/solepro/products';
import { useWishlist } from '~/composables';
import AddToWishlist from '~/components/AddToWishlist.vue';

export default defineComponent({
    name: 'ProductHeading',
    components:{
        AddToWishlist
    },
    props: {
        product: {
            type: Object as PropType<ProductForProductPageType>
        },
        isMain: {
            type: Boolean,
            default: true
        }
    },
    setup(props) {
        const { product } = props || {};
        const productTag = ref({} as productTypeTag);
        const allCategories = ref([]);
        const categoryStore = useCategoryStore();
        const { addOrRemoveItem, isInWishlist, loading } = useWishlist();

        useFetch(async () => {
            await categoryStore.load();
            allCategories.value = categoryStore.rawCategories?.items[0].children;
            productTag.value = getProductTypeTag(allCategories.value, product);
        });

        return {
            productTag,
            allCategories,
            isInWishlist: computed(() => isInWishlist({ product: props.product })),
            addItemToWishlist: addOrRemoveItem,
            loading

        }
    }
})
